import moment from 'moment';

/**
 * Whether "Mark no show" may be used: from the check-in calendar day onward.
 * Days after check-in are also allowed (including checkout day and late processing).
 */
export function canMarkNoShowFromCheckInDate(checkInDate) {
  if (!checkInDate) return false;

  const checkinDay = moment(checkInDate).startOf('day');
  const today = moment().startOf('day');
  return today.isSameOrAfter(checkinDay, 'day');
}

/** @deprecated Use canMarkNoShowFromCheckInDate — kept for older imports. */
export function canMarkNoShowFromCheckoutDate(checkInDate) {
  return canMarkNoShowFromCheckInDate(checkInDate);
}

/** Tooltip when canMarkNoShowFromCheckInDate is false. */
export function noShowEligibilityTooltip(checkInDate) {
  if (!checkInDate) {
    return 'Check-in date is not available for this booking.';
  }
  const checkinDay = moment(checkInDate).startOf('day');
  const today = moment().startOf('day');

  if (today.isBefore(checkinDay, 'day')) {
    return `No show can be marked from ${checkinDay.format('DD MMM YYYY')} onward (check-in date).`;
  }
  return '';
}
